import { Component, signal, effect, inject, ElementRef, HostListener, isWritableSignal, WritableSignal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgOptimizedImage } from '@angular/common';
import { MenuItem } from '../../core/interfaces';
import { EbbaButton } from "../../shared/components/ebba-button/ebba-button";

@Component({
  selector: 'app-navbar',
  imports: [RouterLink, RouterLinkActive, NgOptimizedImage, EbbaButton],
  templateUrl: './navbar.html',
  styleUrl: './navbar.css'
})
export class Navbar {
  private elementRef = inject(ElementRef);
  isMenuOpen = signal(false);
  lang = signal<'EN' | 'AR'>('EN')
  menuItems: MenuItem[] = [
    {
      name: 'Services',
      children: [
        { name: 'Development', link: '/services/development' },
        { name: 'Digital Marketing', link: '/services/digital-marketing' },
        { name: 'Bussiness Solutions', link: '/services/bussiness' },
      ]
    },
    {
      name: 'Industries',
      children: [
        { name: 'E-Commerce', link: '/industries/e-commerce' },
        { name: 'Medical', link: '/industries/medical' },
        { name: 'Media', link: '/industries/media' },
        { name: 'Food & Beverage', link: '/industries/food-and-beverage' },
        { name: 'Real Estates', link: '/industries/real-estate' },
        { name: 'Fashion', link: '/industries/fashion' },
        { name: 'Custom Solutions', link: '/industries/custom-solutions' },
        // { name: 'Education', link: '/industries/education' },

      ]
    },
    { name: 'Projects', link: '/projects' },
    { name: 'About', link: '/about' },
    { name: 'Blogs', link: '/blogs' },
    { name: 'Careers', link: '/careers' }

  ];

  toggleMenu() {
    this.isMenuOpen.update(current => !current);
  }

  closeMenu() {
    this.isMenuOpen.set(false);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    // Check if click is outside the navbar
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.closeMenu();
    }
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.closeMenu();
      this.closeDropdown();
    }
  }

  // Close menu on escape key
  @HostListener('document:keydown.escape')
  onEscapeKey() {
    this.closeMenu();
  }


  changeLang() {
    console.log('clicked');
    this.lang.set(this.lang() === 'EN' ? 'AR' : 'EN');
    console.log('Language changed to:', this.lang());
  }




  activeDropdown = signal<string | null>(null);

  toggleDropdown(name: string) {
    this.activeDropdown.update(current => current === name ? null : name);
  }

  closeDropdown() {
    this.activeDropdown.set(null);
  }


}
